var Formatter = function(){};

var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
    timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
    timezoneClip = /[^-+\dA-Z]/g,
    pad = function (val, len) {
        val = String(val);
        len = len || 2;
        while (val.length < len) val = "0" + val;
        return val;
    };
var dateFormat = {};
// Some common format strings
dateFormat.masks = {
    "default":      "ddd mmm dd yyyy HH:MM:ss",
    shortDate:      "m/d/yy",
    mediumDate:     "mmm d, yyyy",
    longDate:       "mmmm d, yyyy",
    fullDate:       "dddd, mmmm d, yyyy",
    shortTime:      "h:MM TT",
    mediumTime:     "h:MM:ss TT",
    longTime:       "h:MM:ss TT Z",
    isoDate:        "yyyy-mm-dd",
    isoTime:        "HH:MM:ss",
    isoDateTime:    "yyyy-mm-dd'T'HH:MM:ss",
    isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
};
// Internationalization strings
dateFormat.i18n = {
    dayNames: [
        "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
        "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
    ],
    monthNames: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
        "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
    ]
};

Formatter.prototype.money = function(num, c, sym="") {
    if (isNaN(num) || num === null) {
        return "-";
    }
    var n = num,
        c = isNaN(c = Math.abs(c)) ? 0 : c,
        d = d === undefined ? "." : d,
        t = t === undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;
    return s + sym + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

Formatter.prototype.date = function(date, mask, utc) {
    var dF = dateFormat;

    // You can't provide utc if you skip other args (use the "UTC:" mask prefix)
    if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
        mask = date;
        date = undefined;
    }

    // Passing date through Date applies Date.parse, if necessary
    date = date ? new Date(date) : new Date;
    if (isNaN(date)) throw SyntaxError("invalid date");

    mask = String(dF.masks[mask] || mask || dF.masks["default"]);

    // Allow setting the utc argument via the mask
    if (mask.slice(0, 4) == "UTC:") {
        mask = mask.slice(4);
        utc = true;
    }

    var _ = utc ? "getUTC" : "get",
        d = date[_ + "Date"](),
        D = date[_ + "Day"](),
        m = date[_ + "Month"](),
        y = date[_ + "FullYear"](),
        H = date[_ + "Hours"](),
        M = date[_ + "Minutes"](),
        s = date[_ + "Seconds"](),
        L = date[_ + "Milliseconds"](),
        o = utc ? 0 : date.getTimezoneOffset(),
        flags = {
            d:    d,
            dd:   pad(d),
            ddd:  dF.i18n.dayNames[D],
            dddd: dF.i18n.dayNames[D + 7],
            m:    m + 1,
            mm:   pad(m + 1),
            mmm:  dF.i18n.monthNames[m],
            mmmm: dF.i18n.monthNames[m + 12],
            yy:   String(y).slice(2),
            yyyy: y,
            h:    H % 12 || 12,
            hh:   pad(H % 12 || 12),
            H:    H,
            HH:   pad(H),
            M:    M,
            MM:   pad(M),
            s:    s,
            ss:   pad(s),
            l:    pad(L, 3),
            L:    pad(L > 99 ? Math.round(L / 10) : L),
            t:    H < 12 ? "a"  : "p",
            tt:   H < 12 ? "am" : "pm",
            T:    H < 12 ? "A"  : "P",
            TT:   H < 12 ? "AM" : "PM",
            Z:    utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
            o:    (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
            S:    ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
        };

    return mask.replace(token, function ($0) {
        return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
    });
};

Formatter.prototype.prettyMoney_ = function(num, c) {
  var si = [
    { value: 1E12, symbol: "T" },
    { value: 1E9,  symbol: "B" },
    // { value: 1E6,  symbol: "M" },
    { value: 1E3,  symbol: "k" }
  ]
  for (var i=0; i<si.length; i++) {
    if (num >= si[i].value) {
      var rounded = num / si[i].value;
      if (c === undefined) {
        if (rounded < 100) {
          c = 1;
        }
        else if (rounded < 10) {
          c = 2;
        }
        else {
          c = 0;
        }
      }
      return this.money(rounded, c) + si[i].symbol;
    }
  }
  return this.money(num, c);
};

Formatter.prototype.prettyMoney = function(num, c) {
  var si = [
    { value: 1E12, symbol: "T" },
    { value: 1E9,  symbol: "B" },
    { value: 1E6,  symbol: "M" },
    { value: 1E3,  symbol: "K" }
  ]
  for (var i=0; i<si.length; i++) {
    if (num >= si[i].value) {
      var rounded = num / si[i].value;
      if (c === undefined) {
        if (rounded < 100) {
          c = 1;
        }
        else if (rounded < 10) {
          c = 2;
        }
        else {
          c = 0;
        }
      }
      return this.money(rounded, c) + si[i].symbol;
    }
  }
  return this.money(num, c);
};

Formatter.prototype.auto = function(data, hint) {
  if (data === null) {
    return '-'
  }
  if (hint) {
    switch (hint) {
      case 'decimal':
        return this.money(data,2);
      case 'unsigned':
        return data >= 0 ? this.money(data) : 'N.A.';
      case 'number':
        return this.money(data);
      case 'pretty_number':
        return this.prettyMoney(data);
      case 'date':
        return this.date(typeof(data) === 'number' ? data*1000 : data, 'd mmm yy');
        //return this.date(data*1000, 'd mmm yy');
      case 'short_date':
        return this.date(typeof(data) === 'number' ? data*1000 : data, 'mmm yy');
        //return this.date(data*1000, 'mmm yy');
    }
  }
  if (/Z$/.test(data) && Date.parse(data) > 0) {
    return this.date(data, 'd mmm yy');
    //return this.date(data*1000, 'd mmm yy');
  }
  if (isNaN(data)) {
    return data;
  }
  return (data < 500) ? this.money(data,2) : this.money(data);
}

Formatter.prototype.identity = function(value) {
  return value;
};

Formatter.prototype.sqmSqft = function(value) {
  let sqm = value, sqft = value * 10.764;
  return this.money(sqm,1)+ ' sqm / ' + this.money(sqft) + ' sqft';
};

Formatter.prototype.renderTemplate = function(template, item, key, type) {
  return this.auto(
    template ? this.replaceToken(item, template) : this.dotNotation(item, key),
    type
  )
}

Formatter.prototype.dotNotation = function(item, key) {
  return key.split(".").reduce((a,b) => a[b], item);
}

Formatter.prototype.replaceToken = function(item, template) {
  var re = /\[(.*?)\]/g;
  var m = template.match(re);
  return (m || []).reduce((text, match) => {
    var subkey = match.substr(1, match.length-2);
    var replace = this.dotNotation(item, subkey)
    if (replace === null || typeof replace === 'undefined') {
      replace = '';
    }
    return text.replace(match, replace);
  }, template);
}

Formatter.prototype.toSqlDateTime = (inputDate, addSeconds) => {
  const date = new Date(inputDate);
  if (addSeconds > 0) {
    date.setSeconds(date.getSeconds() + addSeconds);
  }
  const dateWithOffest = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
  return dateWithOffest
    .toISOString()
    .slice(0, 19)
    .replace('T', ' ');
}

Formatter.prototype.relativeTime = function(previous) {
    var current = new Date();

    var msPerMinute = 60 * 1000;
    var msPerHour = msPerMinute * 60;
    var msPerDay = msPerHour * 24;
    var msPerMonth = msPerDay * 30;
    var msPerYear = msPerDay * 365;

    var elapsed = current - previous;
    var quantity, unit;
    if (elapsed < msPerMinute) {
      quantity = Math.round(elapsed/1000);
      unit = 'second';
    }
    else if (elapsed < msPerHour) {
      quantity = Math.round(elapsed/msPerMinute);
      unit = 'minute';
    }
    else if (elapsed < msPerDay ) {
      quantity = Math.round(elapsed/msPerHour);
      unit = 'hour';
    }
    else if (elapsed < msPerMonth) {
      quantity = Math.round(elapsed/msPerDay);
      unit = 'day';
    }
    else if (elapsed < msPerYear) {
      quantity = Math.round(elapsed/msPerMonth);
      unit = 'month';
    }
    else {
      quantity = Math.round(elapsed/msPerYear);
      unit = 'year';
    }
    return this.money(quantity) + ' ' + unit + (quantity > 1 ? 's' : '') + ' ago';
}

Formatter.prototype.filesize = function(bytes, decimals) {
    if(bytes == 0) {
        return '0 Bytes';
    }
    var unitMultiple = 1024;
    var unitNames = (unitMultiple === 1024) ? // 1000 bytes in 1 Kilobyte (KB) or 1024 bytes for the binary version (KiB)
        ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']:
        ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var unitChanges = Math.floor(Math.log(bytes) / Math.log(unitMultiple));
    return parseFloat((bytes / Math.pow(unitMultiple, unitChanges)).toFixed(decimals || 0)) + ' ' + unitNames[unitChanges];
}

module.exports = new Formatter();
